import { put, all } from 'redux-saga/effects';
import { createAction, createSlice } from '@reduxjs/toolkit';
import { getCookie, keys, setCookie } from 'lib/storage';
const { ipcRenderer } = window;

interface InitialState {
  responseStatus: number | null;
  responseError: object | any;
  language: string;
  scanProcess: object | any;
  scanEdit: object | any;
  isReScan: boolean;
  installedAppList: any[];
}

const initialState: InitialState = {
  // router에 error 연결(e.g serverError : 500)
  responseStatus: null,
  // responseStatus: 401,
  // TODO: 차후 error toasty또는 popup과 연결 예정
  responseError: {
    isShow: false,
    message: null,
    data: null,
  },
  language: getCookie(keys.language) || 'ko',
  scanProcess: {
    command: null,
    data: null,
  },
  scanEdit: null,
  isReScan: false,
  installedAppList: [],
  // language: 'en',
};

// 팝업 아이디로 사용한다
let _pid = 0;

const slice = createSlice({
  name: 'base',
  initialState,
  reducers: {
    response_status: (state, { payload }) => {
      // DEBUG: 필요
      state.responseStatus = payload;
    },
    response_error: (state, { payload }) => {
      // DEBUG: 필요
      state.responseError.message = payload.message;
      state.responseError.data = payload;
    },
    change_language: (state, { payload }) => {
      state.language = payload;

      setLanguage(payload);
      setCookie(keys.language, payload);
    },

    scan_process: (state, { payload }) => {
      state.scanProcess.command = payload.command;
      state.scanProcess.data = payload.data;
    },
    scan_edit_project: (state, { payload }) => {
      state.scanEdit = payload;
    },
    is_re_scan: (state, { payload }) => {
      state.isReScan = payload;
    },
    set_installed_applist: (state, { payload }) => {
      state.installedAppList = payload;
    },
  },
});

const setLanguage = (payload: string) => {
  if (!!ipcRenderer) {
    ipcRenderer.send('setLanguage', {
      language: payload,
    });
  }
};

export const actions = slice.actions;

// saga
export function* baseSaga() {
  yield all([]);
}

export default slice.reducer;
